/**
 * Constants related to the BP (Business Partner) module.
 *
 * @namespace
 * @property {number} BPTECH - BPTECH constant with value 4.
 * @property {number} BR - BR constant with value 117.
 * @property {number} ERP_BR - ERP_BR constant with value 118.
 * @property {number} ERP_SP - ERP_SP constant with value 119.
 * @property {number} ERP_GERAL - ERP_GERAL constant with value 120.
 */
export const BP = {
  BPTECH: 4,
  BR: 117,
  ERP_BR: 118,
  ERP_SP: 119,
  ERP_GERAL: 120,
  BP_STIP: 123,
  ERP_VIAVANTE: 121,
  BP_TRUCK: 125,
  BPMAISCORRETOR: 126,
  BPVIAVANTEFETRA: 127,
  BPVCMENSAL: 128,
  BP_SINISTRO: 129,
  EMPRESA_130: 130,
};
